// Quizz.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import TechnologieBrowser from "./quiz/TechnologieBrowser";

const Quizz = () => {
  const navigate = useNavigate();

  const handleTechSelect = (techId) => {
    navigate(`/quizz/${techId}`);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="mx-auto">
        <TechnologieBrowser onTechSelect={handleTechSelect} />
      </div>
    </div>
  );
};

export default Quizz;
